import React, { useState, useContext } from "react";
import "../Styles.css";
import "../../common/fileUploads/uploadsStyles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import "../../doctor/doctorProfile/doctorProfile.css";
import "../../../ui-styles/profile/VrtclProfile.css";
import "../../../ui-styles/profile/ProfileDetails.css";
import "../../../ui-styles/centerBlock/centerBlock.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import "../../../layouts/Layouts.css";
import "../../doctor/doctorSettings/doctorSettings.css";
import { LangCtx, CustomCtx } from "../../../lib/context";
// import config from "../../../config.json";
import StripeConfig from "./stripeConfig";
import UploadLogo from "./uploadLogo";
// import PoolConfig from "./poolConfig";
import Degrees from "./degree/degrees";
import Department from "./departments/department";
import Specialization from "./specialization/specialization";
import Branding from "./branding";
import SMTP from "./smtp";
import SMSGateway from "./smsGateway";

const ClinicConfiguration = (props) => {
    const { l } = useContext(LangCtx);
    const { custom } = useContext(CustomCtx);
    const [current, setTab] = useState(custom && custom.subDomain !== process.env.REACT_APP_defaultdomian && custom && custom.logo !== process.env.REACT_APP_logo ? "DP" : "LG");
    
    // const [current, setTab] = useState('DP');

    return (
        <div className="baseContainer">
            <div className="hdngTopCol colBlock ">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{l.config_details}</h2>
                </div>
                <div className="tabCol">
                    <div className="row hndlpdn08 hrztlScroll hideScroll">
                        <div className={current === "DP" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("DP")}>
                            <span>{l.label_dept}</span>
                        </div>
                        <div className={current === "SP" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("SP")}>
                            <span>{l.specialz}</span>
                        </div>

                        <div className={current === "CO" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("CO")}>
                            <span>{l.degrees}</span>
                        </div>
                        {/* {custom && custom.subDomain !== process.env.REACT_APP_defaultdomian && ( */}
                        <div className={current === "LG" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("LG")}>
                            <span>{l.logo}</span>
                        </div>
                        {/* )} */}

                        <div className={current === "BR" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("BR")}>
                            <span>{l.branding}</span>
                        </div>
                        <div className={current === "PY" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("PY")}>
                            <span>{l.payment}</span>
                        </div>
                        <div className={current === "SMG" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("SMG")}>
                            <span>{l.sms}</span>
                        </div>
                        <div className={current === "SMTP" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setTab("SMTP")}>
                            <span>{l.smtp}</span>
                        </div>
                    </div>
                </div>
            </div>

            {current === "DP" && <Department />}
            {current === "SP" && <Specialization />}
            {current === "LG" && <UploadLogo />}
            {current === "PY" && <StripeConfig />}
            {current === "CO" && <Degrees />}
            {current === "BR" && <Branding />}
            {current === "SMG" && <SMSGateway />}
            {current === "SMTP" && <SMTP />}
        </div>
    );
};

export default ClinicConfiguration;
